'use strict';

import { isValidEmail, isDecimal, upToTwoDecimal, alloPositiveOnly } from '../../_assets/abbott/js/_helper';

export default class FormInput {
    constructor() {
        // Floating Label Input Box
        $('.floating-input').each(function () {
            let $this = $(this),
                $parent = $this.parent(),
                $readonly = $this.attr('readonly') == undefined ? '' : 'readonly',
                $isComplete = $this.val() !== '' ? 'complete focus' : '';

            $this
                .wrap('<div class="form-input ' + $isComplete + ' ' + $readonly + '"></div>')
                .before('<span class="placeholder">' + $this.attr('placeholder') + '</span>')
                .attr('placeholder', '')
                .on('focus', function () {
                    let $this = $(this);

                    if ($this.parent().hasClass('readonly')) {
                        return false;
                    }

                    $this.parent().addClass('focus');
                }).on('blur', function () {
                    let $this = $(this),
                        $parent = $this.parent(),
                        $error = $parent.find('.error');

                    if($this.is('.picker__input') ){
                        $parent
                            .removeClass('incomplete')
                            .addClass('complete');
                        return false;
                    }

                    // extracting all comas present on the string.
                    if($this.hasClass('nocoma')){
                        let textNoComa = $this.val().replace(/,/g, "");
                        $this.val(textNoComa);
                    }

                    if ($this.val() === '') {
                        $parent.removeClass('focus');

                        if ($this.attr('required')) {
                            $parent.addClass('incomplete');
                            $error.slideDown({
                                duration: 500,
                                easing: 'easeOutExpo',
                                queue: false
                            });
                        }
                    } else {
                        if ($this[0].type == 'email' && isValidEmail($this.val())) {
                            $parent
                                .removeClass('incomplete')
                                .addClass('complete');

                            $error.slideUp({
                                duration: 500,
                                easing: 'easeOutExpo',
                                queue: false
                            });
                        } else if ($this[0].type == 'email' && !isValidEmail($this.val())) {
                            $parent
                                .addClass('incomplete');

                            $error.slideDown({
                                duration: 500,
                                easing: 'easeOutExpo',
                                queue: false
                            });
                        }
                        else if($this.is("#DobMonth") || $this.is("#UpdateClientDobMonth") || $this.is("#UpdateDobMonth")){
                            if(!isDecimal($this.val())){
                                $this.parent().addClass('incomplete');

                                $('.dob .error')
                                    .text('Only numbers allowed to be entered into month field')
                                    .fadeIn({
                                        duration: 500,
                                        easing: 'easeOutExpo',
                                        queue: false
                                    });
                            }
                            else{
                                $parent.removeClass('incomplete').addClass('complete');

                                $('.dob .error')
                                    .text('Date of birth incorrect, please re-enter')
                                    .fadeOut({
                                        duration: 500,
                                        easing: 'easeOutExpo',
                                        queue: false
                                    });
                            }
                        }
                        else if ($this.val() !== '') {
                            $parent
                                .removeClass('incomplete')
                                .addClass('complete');

                            $error.slideUp({
                                duration: 500,
                                easing: 'easeOutExpo',
                                queue: false
                            });
                        } else {
                            $parent
                                .removeClass('incomplete');

                            $error.slideUp({
                                duration: 500,
                                easing: 'easeOutExpo',
                                queue: false
                            });
                        }
                    }

                }).on('change', function () {
                    let $this = $(this),
                        $parent = $this.parent(),
                        $error = $parent.find('.error');

                    if ($this.val() === '') {
                        $parent.removeClass('focus');

                        if (!$this.attr('required')) {

                            $parent.removeClass('incomplete');
                            $error.slideUp({
                                duration: 500,
                                easing: 'easeOutExpo',
                                queue: false
                            });
                        }
                    }
                });

            if($this.is('.currency-input'))
                $this.after('<span class="currency-symbol"> $ </span>');

            if ($this.data('hint') !== undefined && $this.data('hint') !== '') {
                $this.after('<span class="hint"><strong>*Hint: </strong>' + $this.data('hint') + '</span>');
            }

            if ($this.data('error') !== undefined && $this.data('error') !== '') {
                $this.after('<span class="error">' + $this.data('error') + '</span>');
            }

            $('.placeholder').on('click', function () {
                $(this).next().focus();
            });
        });

        // Resize text area to fill all the text.
        $('textarea').each(function (){

            if($(this).is('.textarea--tooltip')){

                $(this).css({
                    'min-height': '150px'
                });
            }
            else
                autoresize($(this));
        });

        $('textarea').on('keydown', function(){
            autoresize($(this));
        });

        function autoresize(textarea){
            let $this = textarea;

            setTimeout(function(){
                $this.css({
                    'min-height': '53px',
                    'height': 'auto'
                });

                $this.css({
                    'height': $this[0].scrollHeight + 'px'
                });

            }, 0);
        }

        // Show tooltip on textarea
        $('.textarea--tooltip').on('focus', function(){

            let $textarea = $(this),
                $textareaCont = $textarea.parent(),
                content = $textarea.attr('placeholder');

            if($('.tooltip').length > 0)
                return false;

            $('<div class="tooltip">' + content + '<div>')
                .appendTo($textareaCont)
                .hide()
                .fadeIn();
        })
        .on('blur', function(){
            let $tooltip = $(this).parent().find('.tooltip');

            $tooltip
                .fadeOut()
                .remove();
        });

        //input file
        $('input.form-input-file').on('change', function () {
            let fReader = new FileReader(),
                // replacing the full path of the file for just its name.
                fileName = $(this).val().split('\\').pop();

            $('.fake-input input')
                .focus()
                .val(fileName)
                .blur();
        });

        //input number: allow up to two decimal places
        let oldNumber;
        $('input[type="number"]').on('keydown', function(e){

            if(alloPositiveOnly(e))
                return false;

            let $this = $(this),
                newNumber = $this.val();

            if($this.attr('step') === '0.01'){

                 if(!upToTwoDecimal(newNumber))
                    e.preventDefault();

                oldNumber = newNumber;
            }
        }).on('keyup', function(e){
            let $this = $(this);
            
            if(!upToTwoDecimal($this.val()))
                $this.val(oldNumber);
        });
    }
}
